import { ZAttrMeta, zAttrMeta } from "./ZAttrMeta";

/**
 * Удаление вложенного атрибута
 * @param srcOwner Исходный атртибут типа (не изменяется)
 * @param target Удаляемый атрибут
 * @returns undefined, если не произошло изменений. Либо новый экземпляр атрибута.
 */
export const deleteSubAttr = (
  srcOwner: ZAttrMeta,
  target: ZAttrMeta,
): ZAttrMeta | undefined => {
  const dstOwner = zAttrMeta.parse(srcOwner);
  const { type } = dstOwner;
  if (type.name !== "list") return undefined;

  // Поиск среди непосредственных подчинённых полей
  const fields = type?.fields ?? [];
  const pos = fields.findIndex((a) => a.uid === target.uid);
  if (pos >= 0) {
    fields.splice(pos, 1);
    return dstOwner;
  }

  // рекурсивное удаление
  // eslint-disable-next-line guard-for-in, no-restricted-syntax
  for (const index in fields) {
    const dstAttr = deleteSubAttr(fields[index]!, target);
    if (dstAttr) {
      fields[index] = dstAttr;
      return dstOwner;
    }
  }
  return undefined;
};
